/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ProgramEnvironmentalBenefitsTargetValueViewer} from "./ProgramEnvironmentalBenefitsTargetValueViewer";

export const ProjectedProgramEnvironmentalBenefitsTargetValueViewer = (props) => {

	const { RootData = {}, Data } = props;
	const { ProgramEnvironmentalBenefits = [] } = RootData;
	const projectionId = Data.programEnvironmentalBenefitProjectionId || Data._tempId;

	const environmentalBenefitId = ProgramEnvironmentalBenefits.find(
		benefit => benefit.ProgramEnvironmentalBenefitProjections?.some(
			projection => projection.programEnvironmentalBenefitProjectionId == projectionId
		)
	)?.environmentalBenefitId ?? -1;

	return <ProgramEnvironmentalBenefitsTargetValueViewer
		{...props}
		environmentalBenefitId={environmentalBenefitId}
	/>
	
}
